import type {FC} from 'react'
import {useDownloadAttachment} from 'hooks/api/egovProcedureStatuses/attachments/useDownloadAttachment'
import {useSelector} from 'hooks/redux'

// @ts-ignore
import {isLimitedAdminSelector} from 'utils'

interface EgovProcedure {
  id: string
}

interface Attachment {
  id: string
  fileName: string
  fileUrl: string
  printedMynumber: boolean
}

interface AttachmentItemProps {
  egovProcedure: EgovProcedure
  attachment: Attachment
}

export const AttachmentItem: FC<AttachmentItemProps> = ({egovProcedure, attachment}) => {
  const attachmentDownload = useDownloadAttachment()
  const isLimitedAdmin = useSelector(isLimitedAdminSelector)

  if (attachment.printedMynumber && isLimitedAdmin) {
    return <div>マイナンバーを含む書類の為、閲覧・ダウンロード出来ません</div>
  } else {
    return (
      <a className="u-txt-link" onClick={() => attachmentDownload(egovProcedure.id, attachment.id)}>
        {attachment.fileName}
      </a>
    )
  }
}
